import React, {Component} from "react";
import {connect} from "react-redux";
import {NavLink, withRouter} from "react-router-dom";
import {Col, Modal, ModalBody, ModalFooter, ModalHeader, Row, Table} from "reactstrap";
import {toast} from "react-toastify";

import {getEntity} from "../../../services/entity/entity-service";

import Button from "../../components/button/button";
import FormSection from "../../components/form-section/form-section";
import Hr from "../../components/hr/hr";
import InputCheckbox from "../../components/input-checkbox/input-checkbox";
import Input from "../../components/input/input";
import PlayerDashboardButtons from "../../components/player-dashboard-buttons/player-dashboard-buttons";

import {createPlayer, getPlayer, resetPlayerState, updatePlayer, getOnePlayer, getPlayerTeamMembers} from "../../../modules/player";
import {setPageTitle} from "../../../modules/application/pages";
import {getSkills} from "../../../modules/system/skill";
import {getTeamMembers} from "../../../modules/user"; 

import "./player-form.css";

class PlayerForm extends Component {
    constructor(props) { 
        super(props);
        this.state = {
            owner: this.props.currentUserId,

            name: "",

            selectedCheckboxes: new Set(),
            age: "",
            notes: "",

            isEdit: false,
            showModal: false,

            player: {},
            availableTeamMembers: [],
            assignedTeamMembers: []
        };

        this.player = {};
        this.props.dispatch(resetPlayerState());
        this.submitPlayer = this.submitPlayer.bind(this)
    }

    componentDidMount() {
        this.props.dispatch(getSkills());
        this.setPlayer(this.props.match.params.id)
    }

    async setPlayer(playerId) {
        const {dispatch, token, currentUser} = this.props;

        let assignedTeamMembers = [];
        //const users = await getEntity(dispatch, getUsers([], "first_name,last_name"), true);        
        if (currentUser && currentUser.user) {
            let currentUserParsed = currentUser.user;
            currentUserParsed.name = currentUserParsed.first_name + " " + currentUserParsed.last_name; 
            assignedTeamMembers.push(currentUserParsed);
        }
        
        if (playerId) {
            let assignedTeamMembersResponse = await getPlayerTeamMembers(playerId, token);
            assignedTeamMembers = assignedTeamMembersResponse.data.player_team_members
        } 
        



        const teamMembersResponse = await getTeamMembers(token, false);
        const teamMembers = teamMembersResponse.data.team_members;

        if (!playerId) {
            this.props.dispatch(setPageTitle("Create Player"));

            const availableTeamMembers = teamMembers.filter(user => {
                for (let index in assignedTeamMembers) {
                    let currentAssigned = assignedTeamMembers[index];

                    if (currentAssigned.id === user.id) {
                        return false;
                    }
                }

                return true;
            });

            if (currentUser && currentUser.user) {
                let player = {
                    owner_id: currentUser.user.id
                };

                this.setState({player});
            }
            
            this.setState({assignedTeamMembers, availableTeamMembers});

            return;
        }

        let playerResponse = await getOnePlayer(playerId, token);
        let player = playerResponse.data.player_data;
       
        //const player = await getEntity(dispatch, getPlayer(playerId));
        const skills = await getEntity(dispatch, getSkills(), true);

        this.props.dispatch(setPageTitle(player.name));

        const selectedCheckboxes = new Set();
        player.skills && player.skills.forEach(skill => {
            const foundSkill = skills.filter(propSkill => {
                return skill.id === propSkill.id
            });
            selectedCheckboxes.add(foundSkill[0].name);
        });
        
        let ownerFound = assignedTeamMembers.find(user => {
            return user.id === player.owner_id
        });

        if (!ownerFound) {
            assignedTeamMembers.unshift({
                "name": player.owner_name,
                "id": player.owner_id
            })
        }

        const availableTeamMembers = teamMembers.filter(user => {
            return !assignedTeamMembers.find(assigned => assigned.id === user.id)
        });


        this.setState({isEdit: true, selectedCheckboxes, player, assignedTeamMembers, availableTeamMembers, ...player});
    }


    async submitPlayer() {
        const checkedSkills = this.props.skills
            .filter(skill => {
                return this.state.selectedCheckboxes.has(skill.name)
            })
            .map(skill => {
                return skill.id
            });

        if (this.state.name === "") {
            toast.error("Please give your player a Name.", {
                position: toast.POSITION.TOP_CENTER
            });
            return
        }

        if (!this.state.age || this.state.age === 0) {
            toast.error("Please enter an Age for your player.", {
                position: toast.POSITION.TOP_CENTER
            });
            return
        }

        if (checkedSkills.length === 0) {
            toast.error("Please select at least one Skill for your player.", {
                position: toast.POSITION.TOP_CENTER
            });
            return
        }

        const {dispatch} = this.props;
        const {owner, name, age, notes, assignedTeamMembers} = this.state;
        const player = {
            owner,
            name,
            age: parseInt(age, 10),
            notes,
            skills: checkedSkills,
            team_members: assignedTeamMembers.map(teamMember => teamMember.id)
        };

        if (this.state.isEdit) {
            await getEntity(dispatch, updatePlayer(this.state.player.id, player));
            const nextRoute = this.props.location.returnRoute ? this.props.location.returnRoute : "/therapistDashboard";
            this.props.history.push(`${nextRoute}?message=Updated player! ${this.state.name}`);
        } else {
            const entityResponse = await getEntity(dispatch, createPlayer(player));
            const playerId = entityResponse.id;
            this.player = await getEntity(dispatch, getPlayer(playerId));
            this.setState({showModal: true});
        }
    }

    render() {
        const returnRoute = this.props.location.returnRoute;
        const submitButtonLabel = this.state.isEdit
            ? "Save"
            : "Create Player";

        const cancelRoute = returnRoute
            ? returnRoute
            : "/therapistDashboard";

        return (
            <div className="px-1 container-fluid">
                <FormSection
                    component={this.playerForm(submitButtonLabel, cancelRoute)}
                />
            </div>
        )
    }

    playerForm(submitButtonLabel, cancelRoute) {
        const {isTherapistRole} = this.props;
        const {player, assignedTeamMembers, availableTeamMembers} = this.state;

        const availableTeamMembersComponent = this.teamMembersComponent(assignedTeamMembers, player, null, true);
        const assignedTeamMembersComponent = this.teamMembersComponent(availableTeamMembers, player, null, false);

        const playerTeamMembers = <Row className="mp-0">
            {assignedTeamMembersComponent}
            {availableTeamMembersComponent}
        </Row>;

        return <div className="mp-0 container-fluid">
            {this.props.location.returnRoute && (
                <PlayerDashboardButtons player={player} activePage="back" isTherapistRole={isTherapistRole} />
                )}
            <Col className="mx-1 my-1 pl-0 pr-3 py-0 text-left">
                <FormSection
                    sectionLabel="Personal Information"
                    component={
                        <div className="px-3 text-left container-fluid">
                            <div className="ml-0 pl-0 col-6">
                                <Input
                                    name="name"
                                    value={this.state.name}
                                    onChange={name => {
                                        this.setState({name});
                                    }}
                                    label="Name"
                                />
                            </div>
                            <div className="ml-0 pl-0 col-4">
                                <Input
                                    name="age"
                                    value={this.state.age}
                                    onChange={age => {
                                        this.setState({age});
                                    }}
                                    label="Age"
                                    type="number"
                                />
                            </div>
                            <Hr/>
                            <Input
                                name="notes"
                                value={this.state.notes}
                                onChange={notes => {
                                    this.setState({notes});
                                }}
                                placeholder="Notes"
                                type="textarea"
                            />
                        </div>
                    }/>

                <FormSection
                    sectionLabel="Goals"
                    component={this.createCheckboxes(this.state.selectedCheckboxes)}/>

                {playerTeamMembers}
                <div className="mt-3 mb-2 text-right">
                    <Button
                        className="ml-1"
                        text="Cancel"
                        outline
                        onClick={() => {
                            this.props.history.push(cancelRoute);
                        }}
                        color="info"
                    />
                    <Button
                        className="ml-1"
                        text={submitButtonLabel}
                        onClick={() => {
                            this.submitPlayer();
                        }}
                        color="primary"
                    />
                </div>

                <Modal isOpen={this.state.showModal} className={this.props.className} backdrop={this.state.backdrop}>
                    <ModalHeader><h6>Sessions</h6></ModalHeader>
                    <ModalBody>
                        <span className="font-weight-bold">{this.state.name}</span> doesn’t have a session,
                        let’s create their first one!</ModalBody>
                    <ModalFooter>
                        <NavLink to={{
                            pathname: `/player/${this.player.id}/dashboard`,
                            player: this.player
                        }}>
                            <Button className="ml-3" color="secondary" text="Skip"/>
                        </NavLink>

                        <NavLink to={{
                            pathname: `/gameSession`,
                            player: this.player
                        }}>
                            <Button className="ml-3" color="success" text="Start"/>
                        </NavLink>

                        <Button className="ml-3" color="primary" onClick={() => {
                            this.props.history.replace("sessionBank")
                        }} text="Add from Bank"/>
                    </ModalFooter>
                </Modal>
            </Col>
        </div>;
    }

    createCheckboxes = (skills) => {
        const skillsColumns = 4;
        const chunkedSkills = chunkArray(this.props.skills, skillsColumns);

        // this could be turned into a nested map statement
        for (let chunkOfSkills of chunkedSkills) {
            for (let chunkSkill of chunkOfSkills) {
                if (chunkSkill === null) {
                    continue
                }

                chunkSkill.ischecked = skills && skills.has(chunkSkill.name);
            }
        }

        return (
            <Table className="mx-2 small">
                <tbody>
                {
                    chunkedSkills.map((checkboxGroup, index) => {
                        return (
                            <tr key={`skill_row_${index}`}>
                                {checkboxGroup.map((skill) => {
                                    return this.createCheckbox(skill)
                                })}
                            </tr>
                        )
                    })
                }
                </tbody>
            </Table>
        )
    };

    createCheckbox = (checkboxSkill) => {
        const checkboxId = !checkboxSkill || checkboxSkill !== null
            ? Math.random()
            : `${checkboxSkill.name}_${checkboxSkill.id}`;

        return checkboxSkill
            ? <td className="py-0 my-0 text-left" key={checkboxId}>
                <InputCheckbox
                    ischecked={checkboxSkill.ischecked}
                    label={checkboxSkill.name}
                    handlecheckboxchange={
                        label => {
                            const {selectedCheckboxes} = this.state;
                            if (selectedCheckboxes.has(label)) {
                                selectedCheckboxes.delete(label);
                            } else {
                                selectedCheckboxes.add(label);
                            }
                            this.setState(selectedCheckboxes)
                        }
                    }
                    key={checkboxSkill.id}
                    id={checkboxId}
                />
            </td>
            : <td>&nbsp;</td>;
    };

    teamMembersComponent = (teamMembers, player, onMove, isAssigned) => {
        return <div className='mx-1'>
            <Table striped bordered className="m-1 p-0 Player-Team-Members-table">
                <thead>
                <tr className="pl-2 text-left">
                    <th className="m-0 p-0">
                        {isAssigned ? "Assigned" : "Available"} Team Members
                    </th>
                </tr>
                </thead>
                <tbody>
                {teamMembers && teamMembers.map(
                    teamMember => {
                        const isOwner = player.owner_id === teamMember.id;
                        return <tr className="text-left" title={""}>
                            <td className="m-1 p-1" style={{width: "100%"}}>
                                {teamMember.name} {isOwner && "(Owner)"}
                            </td>
                            <td className="my-auto mx-0 p-0">
                                <Button
                                    className="btn-sm"
                                    disabled={isOwner}
                                    text={isAssigned ? "Remove" : "Assign"}
                                    color={isAssigned ? "info" : "success"}
                                    onClick={() => {
                                        this.onMoveTeamMember(teamMember, player, !isAssigned)
                                    }}
                                />
                            </td>
                        </tr>
                    })
                }
                </tbody>
            </Table>
        </div>
    };

    async onMoveTeamMember(teamMember, player, isAssigned) {
        let {assignedTeamMembers, availableTeamMembers} = this.state;

        const isFound = assignedTeamMembers.find(user => {
            return user.id === teamMember.id
        });

        if (!isAssigned && isFound) {
            availableTeamMembers.push(teamMember);
            assignedTeamMembers = assignedTeamMembers.filter(_teamMember => {
                return _teamMember.id !== teamMember.id
            })
        } else if (isAssigned && !isFound) {
            assignedTeamMembers.push(teamMember);
            availableTeamMembers = availableTeamMembers.filter(_teamMember => {
                return _teamMember.id !== teamMember.id
            })
        }

        this.setState({assignedTeamMembers, availableTeamMembers});
    };
}

function chunkArray(array, chunk) {
    const chunks = [];

    if (!array || array.length === 0) {
        return chunks
    }

    let j = array.length;

    for (let i = 0; i < j; i += chunk) {
        const slice = array.slice(i, i + chunk);

        while (slice.length < chunk) {
            slice.push(null)
        }

        chunks.push(slice);
    }

    return chunks
}

const withState = connect(state => {
    const {user, skill,} = state;

    const skill_checkboxes = skill.skills.map(skill => {
        return {name: skill.name, id: skill.id}
    });
    return {
        token: user.token,
        currentUser: user,        
        currentUserId: user.currentUserId,
        isTherapistRole: user.isTherapistRole,
        skills: skill_checkboxes
    };
});
export default withRouter(withState(PlayerForm));



// WEBPACK FOOTER //
// ./src/components/containers/player-form/player-form.js